import usePrivateAxios from "@/common/api/usePrivateAxios"
import { removeSpecialCharacters } from "@/common/utils/unFormatters"
import { EstablishmentLeadsFunnelUpdateContactValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";

interface UseUpdateEstablishmentLeadContact {
  contactId?: string,
  establishmentLeadId?: string,
  onSuccess?: (response: AxiosResponse) => void,
  onError?: (error: any) => void
}

export const useUpdateEstablishmentLeadContact = ({ contactId, establishmentLeadId, onSuccess, onError }: UseUpdateEstablishmentLeadContact) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateEstablishmentLeadContact'],
    mutationFn: (data: EstablishmentLeadsFunnelUpdateContactValidationSchema) => {
      const lead = {
        contacts_attributes: [
          {
            ...data.contacts,
            id: contactId,
            phone_attributes: {
              number: data.contacts.phone_attributes?.number ? removeSpecialCharacters(data.contacts.phone_attributes.number) : '',
            },
            cpf: data.contacts.cpf ? removeSpecialCharacters(data.contacts.cpf) : null,
            documents_attributes: data.contacts.documents.map((document) => {
              if (document?.checked) {
                const doc = {
                  ...document,
                  cnh: document.cnh ? removeSpecialCharacters(document.cnh) : null,
                }

                delete doc.type

                return doc
              }

              return null
            }),
          }
        ]
      }

      return privateAxios.putForm(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
